var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconDogUrination(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 57.2 33.3",
    style: {
      enableBackground: "new 0 0 57.2 33.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#C10000;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1375",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3974",
    className: "st0",
    d: "M40.9,8c-0.5,0,1-0.8-5.5-0.9c-5.8,0-11.6,1.1-17,3.4c0,0-0.1,0-0.1,0l-4,1 c-2.8-1.1-4.9-2.3-4.3-4.9c1.1-4.6,3.7-5.3,2.8-6.4c-0.5-0.5-2.2,0.2-3.7,1.8C7.7,3.4,6.9,5.4,7,7.4c0.3,3.8,3.5,5.7,5.7,6.9 l-0.6,0.3c-1.4-0.7-2.7-1.6-3.8-2.8l-0.8-0.4C7,11,6.3,11.1,5.8,11.5L1.5,15c-0.2,0.2-0.4,0.4-0.5,0.7l-0.9,2.4 c-0.3,0.9,0.2,1.8,1,2.1c0.8,0.3,1.7-0.1,2.1-1l0.7-1.9L7,14.8l2.9,1.6c0.2,0.1,0.5,0.2,0.8,0.2l2.1,0l1.9,5.2 c0,0.1,0.1,0.2,0.1,0.3l-2.4,3.1c-0.3,0.4-0.4,1-0.2,1.6l1.7,4.7c0.2,0.4,0.5,0.8,0.9,0.9l1.8,0.8c0.8,0.4,1.8,0,2.2-0.8 s0-1.8-0.8-2.2l-1.1-0.5l-1.2-3.2l3-3.9c0.2-0.2,0.3-0.5,0.3-0.8l0.2-2c2.3-0.1,3.9,0.3,7.9,1.7c3.9,1.3,5.7,0.1,7.1-1.4l1.9,5.4 c0,0.1,0.1,0.2,0.1,0.3l3.4,5.6c0.1,0.2,0.3,0.4,0.6,0.5l1.5,0.7c0.7,0.3,1.5,0.1,1.8-0.6c0.3-0.6,0.1-1.4-0.5-1.8l-1.1-0.7 l-2.5-5.1c0,0-0.7-5.6-0.7-5.6l0,0c1.3,0,2.6,0.2,3.8,0.6c1.5,0.6-1.1-3.4-1.5-5.8C40.7,11.7,40.7,9.8,40.9,8z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_37",
    className: "st0",
    cx: 29.6,
    cy: 30.7,
    rx: 4.7,
    ry: 0.6
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_38",
    className: "st0",
    cx: 25.6,
    cy: 29.6,
    rx: 1.3,
    ry: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3975",
    className: "st0",
    d: "M33.4,32.1c0-0.1-0.6-0.2-1.3-0.2s-1.3,0.1-1.3,0.2s0.6,0.2,1.3,0.2S33.4,32.2,33.4,32.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3999",
    className: "st0",
    d: "M46,9.4c-0.4-0.9-0.9-2.1-1.4-3.2C43.9,4.6,43.2,6,43.2,6L43,7.7c-0.4-0.1-0.7-0.1-1.2-0.1 c-0.2,2.2,0,4.5,0.5,6.7c0.9,4.1,2.3,5,2.3,5c3.2,0.8,7.7,1.7,9.1,0.6c3.7-3.1,3.9-4.2,3.1-5.2C55.8,13.6,49.8,11,46,9.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4006",
    className: "st0",
    d: "M19.3,20.6c0,0,7.6-0.1,11.7,9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4007",
    className: "st0",
    d: "M19.3,20.6c0,0,7.6,1.2,10.1,10.7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDogUrination);
export default __webpack_public_path__ + "static/media/icon-dog-urination.bfcaab8e63ae0acd7506026bc1a8f082.svg";
export { ForwardRef as ReactComponent };